import React, { useState,
  // useRef,
  useEffect } from "react";
import { connect } from "react-redux";
import { API_ROOT } from "../../../../baseUrls";
import AvatarDialog from "../../dialogs/AvatarDialog";
import {
  Avatar,
  Box,
} from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";

function MindfileAvatar({ user, mindfile }) {
  const userId = user.uid ? user.uid : null;
  const mindfileOwnerId = mindfile.owner ? mindfile.owner : null;
  const contributors = mindfile.contributors || [];
  const contributorIds = contributors.map(contributor => contributor.id);
  const updatingAvatar = mindfile.picturesUploading > 0;
  const ownerStyle =
    userId === mindfileOwnerId
      ? { border: "4px solid #003e58", cursor: "pointer" }
      : {};
  const contributorStyle = contributorIds.includes(userId)
    ? { cursor: "pointer" }
    : {};

  const [openDialog, setOpenDialog] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState("");

  useEffect(() => {
    if (updatingAvatar
          || typeof(mindfile) === 'undefined' || !mindfile
          || typeof(mindfile.id) === 'undefined' || !mindfile.id) {
      setAvatarUrl("");
    } else {
      setAvatarUrl(
        `${API_ROOT}/mindfiles/${mindfile.id}/avatar/thumbnail?size=48&ts=${mindfile.timestamp}`
      );
    }
  }, [mindfile, updatingAvatar]);

  const openIfAllowed = () => {
    if (userId === mindfileOwnerId || contributorIds.includes(userId)) {
      setOpenDialog(true);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <Avatar
        id="viewingMindfileAvatar"
        alt={mindfile.name}
        src={avatarUrl}
        style={{ ...ownerStyle, ...contributorStyle }}
        onClick={openIfAllowed}
      />
      {!mindfile.has_avatar_photo &&
      (userId === mindfileOwnerId || contributorIds.includes(userId)) ? (
        <Box
          style={{
            borderRadius: "50%",
            backgroundColor: "#003e58",
            position: "absolute",
            right: 0,
            top: 28,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 4,
          }}
          onClick={openIfAllowed}
        >
          <EditIcon style={{ color: "white", fontSize: 14 }} />
        </Box>
      ) : null}
      <AvatarDialog
        isOpen={openDialog}
        closeDialog={() => setOpenDialog(false)}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfile: state.mindfile,
});

export default connect(mapStateToProps)(MindfileAvatar);
